<template lang="html">
    <entity-page id="page__auto" v-loader-overlay="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
        <div class="row">
            <z-select
                label="Тип"
                v-model="auto.type"
                v-validate="'required'" 
                name="type"
                id="type"
                data-vv-as=" "
                data-vv-name="type"
                v-bind:error="errors.first('type')"
                class="col-6"
            >
                <option selected disabled value=""> Не установленно </option>
                <option v-bind:value="1"> Автофургон </option>
                <option v-bind:value="2"> Тягач </option>
                <option v-bind:value="3"> Прицеп </option>
                <option v-bind:value="4"> Открытое авто </option>
            </z-select>

            <z-input
                v-bind:label="numberLabel"
                name="number" id="number" v-model="auto.number" 
                v-validate="'required|min:1|max:11'" v-bind:error="errors.first('number')"
                data-vv-name="number" class="col-6"
                v-bind:data-vv-as="' '"
                mask="A 999 AA 99"
                placegolder="A 999 AA 99"
            ></z-input>

            <z-input 
                name="brand" id="brand" label="Марка" v-model="auto.brand" 
                v-validate="'min:1|max:50'" v-bind:error="errors.first('brand')"
                data-vv-name="brand" class="col-6"
                v-bind:data-vv-as="' '"
            ></z-input>

            <z-input
                name="max_seats" id="max_seats" label="Макс. кол-во мест" v-model="auto.max_seats" 
                v-validate="'integer|min:0|max:9999'" v-bind:error="errors.first('max_seats')"
                data-vv-name="max_seats" class="col-6"
                v-bind:data-vv-as="' '"
            ></z-input>

            <z-input
                name="max_weight" id="max_weight" label="Макс. вес (грузоподъемность)" v-model="auto.max_weight" 
                v-validate="'decimal|min:0|max:9999'" v-bind:error="errors.first('max_weight')"
                data-vv-name="max_weight" class="col-6"
                v-bind:data-vv-as="' '"
            ></z-input>

            <z-input
                name="max_volume" id="max_volume" label="Макс. объём" v-model="auto.max_volume" 
                v-validate="'decimal|min:0|max:9999'" v-bind:error="errors.first('max_volume')"
                data-vv-name="max_volume"
                v-bind:data-vv-as="' '" class="col-6"
            ></z-input>
        </div>
    </entity-page>
</template>
<script>
    import autocomplete from '@/components/autocomplete';
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import ZIconButton  from '@/components/ZIconButton.vue';
    import EntityPage  from '@/components/EntityPage.vue';
    export default {
        components: {autocomplete, ZInput, ZSelect, ZIconButton, EntityPage},
        data() {
            return {
                auto: {},
                defaultAuto: {
                    id: null,
                    driver_id: null,
                    number: null,
                    trailer: null,
                    brand: null,
                    max_seats: 0,
                    max_weight: 0,
                    max_volume: 0,
                    type: ''
                },
            }
        },
        created() {
            this.init();
            this.listeners();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('openRightPanel');
                this.$nextTick(() => {
                    this.auto = Object.assign({}, this.defaultAuto);
                    if (this.$route.params.auto_id != 'new') this.getAuto();
                });
            },
            /**
             * Возвращает пользователя на предидущую страницу
             */
            back() {
                this.$router.push({name: 'Autos', query: this.$route.query});
            },
            listeners() {
                this.$root.$on('update-auto-form', id => {
                    if (parseInt(id) === parseInt(this.$route.params.auto_id)) this.init();
                });
            },
            /**
             * Добавление ТС
             */
            postAuto() {
                this.$store.commit('showProgressBar', 'load-auto-card');
                this.$store.dispatch('deals/postAuto', this.auto).then((r) => {
                    this.$root.$emit('reload-table', 'autos'),
                    this.$router.replace({name: 'Auto', params: {auto_id: r.id}})
                }).finally(() => this.$store.commit('hideProgressBar', 'load-auto-card'));
            },
            /**
             * Изменение ТС
             */
            putAuto() {
                this.$store.commit('showProgressBar', 'load-auto-card');
                this.$store.dispatch('deals/putAuto', this.auto).then(() => {
                    this.init();
                    this.$root.$emit('reload-table', 'autos');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-auto-card'));
            },
            /**
             * Сохранение ТС
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.auto_id != 'new') this.putAuto();
                    else this.postAuto();
                });
            },
            /**
             * Получение ТС
             */
            getAuto() {
                this.$store.commit('showProgressBar', 'load-auto-card');
                return this.$store.dispatch('deals/getAuto', this.$route.params.auto_id).then(auto => {
                    if (auto) this.auto = Object.assign({}, auto);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-auto-card'));
            },
        },
        computed: {
            /**
             * Флаг закгрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-auto-card'];
            },
            /**
             * Объект с флагами загрузки 
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Присвоение заголовка
             */
            numberLabel() {
                switch (this.auto.type) {
                    case 0: return 'Государственный номер (Формат: A 123 AA 27)';
                    case 1: return 'Номер автофургона (Формат: A 123 AA 27)';
                    case 2: return 'Номер тягача (Формат: A 123 AA 27)';
                    case 3: return 'Номер прицепа (Формат: A 123 AA 27)';
                }
                return 'Государственный номер (Формат: A 123 AA 27)';
            }
        },
        watch: {
            '$route.params.auto_id'(id) {
                this.init();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Auto.vue?7dd13b02